export default __webpack_public_path__ + "static/media/study-about-4.067bdb4b.png";